import React from "react";
import { InputGroup } from "react-bootstrap";
import { FieldFeedbackLabel } from "./FieldFeedbackLabel";

const getFieldCSSClasses = (touched, errors) => {
  const classes = ["form-control"];
  if (touched && errors) {
    classes.push("is-invalid");
  }

  if (touched && !errors) {
    classes.push("is-valid");
  }

  return classes.join(" ");
};

export const formatPriceString = (val) => {
  if (val === undefined || val === null || val === "") return "";
  const str = val.toString().replace(/,/g, "");
  const parts = str.split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
};

export function PriceInput({
  field, // { name, value, onChange, onBlur }
  form, // { touched, errors, setFieldValue, setFieldTouched }
  label,
  withFeedbackLabel = true,
  customFeedbackLabel,
  unit = "ریال",
  disabled = false,
  placeholder,
  ...props
}) {
  const { touched, errors, setFieldValue, setFieldTouched } = form || {};
  const isTouched = touched && field ? touched[field.name] : false;
  const isError = errors && field ? errors[field.name] : undefined;

  const displayValue = formatPriceString(field ? field.value : "");

  const handleChange = (e) => {
    const rawVal = e.target.value.replace(/,/g, "").replace(/[^\d-]/g, "");
    if (rawVal === "" || rawVal === "-") {
      if (setFieldValue && field) {
        setFieldValue(field.name, rawVal === "" ? "" : rawVal);
      }
    } else {
      const numVal = Number(rawVal);
      if (setFieldValue && field) {
        setFieldValue(field.name, isNaN(numVal) ? "" : numVal);
      }
    }
  };

  const handleBlur = (e) => {
    if (field && field.onBlur) {
      field.onBlur(e);
    }
    if (setFieldTouched && field) {
      setFieldTouched(field.name, true);
    }
  };

  return (
    <>
      {label && <label>{label}</label>}
      <InputGroup className="mb-0">
        <input
          type="text"
          inputMode="numeric"
          className={getFieldCSSClasses(isTouched, isError)}
          name={field ? field.name : props.name}
          value={displayValue}
          onChange={handleChange}
          onBlur={handleBlur}
          disabled={disabled}
          placeholder={placeholder}
          {...props}
        />
        {unit && (
          <InputGroup.Append>
            <InputGroup.Text style={{ minWidth: "50px", justifyContent: "center" }}>
              {unit}
            </InputGroup.Text>
          </InputGroup.Append>
        )}
      </InputGroup>
      {withFeedbackLabel && field && (
        <FieldFeedbackLabel
          error={isError}
          touched={isTouched}
          label={label}
          type="text"
          customFeedbackLabel={customFeedbackLabel}
        />
      )}
    </>
  );
}
